// Several special relative date "shortcut" operators exist on the client to make it easy to configure
// common RELATIVE_RANGE filters. These only exist on the client and are mapped to the more general
// RELATIVE_RANGE operator so that we leave flexibility to change the "shortcut" operators exposed without
// creating backwards compatibility issues. To support this, shortcut operators need to be mapped to the
// RELATIVE_RANGE operator with the relevant value, and values need to be mapped to the shortcut operators
// when they match. Note that the latter point means that if a user configures a "custom range" in the UI,
// with a range that matches one of the shortcut operators, it will get converted to the shortcut operator
// on apply.

import {
  Operator,
  RELATIVE_RANGE_SHORTCUT_OPERATORS,
  RelativeRangeUnits,
  StandardFilter,
  StandardRelativeRangeOperatorValue,
} from 'search/SearchConstants';

export function finalizeRelativeRangeFilter(filter: StandardFilter): StandardFilter {
  if (RELATIVE_RANGE_SHORTCUT_OPERATORS.includes(filter.operator)) {
    return {...filter, operator: Operator.RELATIVE_RANGE};
  }
  return filter;
}

export function mapRelativeRangeValueToShortcutOperator(value: StandardRelativeRangeOperatorValue): Operator {
  if (value.from === 1 && value.fromUnits === RelativeRangeUnits.WEEKS && !value.toUnits) {
    return Operator.LAST_WEEK;
  } else if (value.from === 1 && value.fromUnits === RelativeRangeUnits.MONTHS && !value.toUnits) {
    return Operator.LAST_MONTH;
  } else if (value.to === 1 && value.toUnits === RelativeRangeUnits.WEEKS && !value.fromUnits) {
    return Operator.NEXT_WEEK;
  } else if (value.to === 1 && value.toUnits === RelativeRangeUnits.MONTHS && !value.fromUnits) {
    return Operator.NEXT_MONTH;
  } else {
    return Operator.RELATIVE_RANGE;
  }
}
